import React, { useContext } from "react";

import { TranslationContext } from "@swegon/sds-core";

import { Context as ReleaseActivatedContext } from "../ahu/ReleaseActivatedContext";
import { Indicator, ReleaseButton, ReloadIcon } from "./ReleaseNotice.styles";

export const ReleaseNotice = () => {
    const { notice, saveAndReload } = useContext(ReleaseActivatedContext);
    const { l } = useContext(TranslationContext);

    if (!notice) {
        return null;
    }

    return (
        <ReleaseButton
            data-testid='action-release-save-and-reload'
            disabled={notice.reloading}
            onClick={saveAndReload}
            type='button'
        >
            <Indicator aria-hidden='true' />
            <span>{l("release.clickToSaveAndReload")}</span>
            <ReloadIcon aria-hidden='true' viewBox='0 0 24 24' fill='none' stroke='currentColor'>
                <path
                    d='M20 12a8 8 0 1 1-2.34-5.66M20 4v5h-5'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </ReloadIcon>
        </ReleaseButton>
    );
};

export default ReleaseNotice;
